import { createContext, useContext } from "react";
import { useModalAsk } from "../hooks/useModalAsk";
const Context = createContext();

export const ModalAskProvider = ({ children }) => {
  return <Context.Provider value={useModalAsk()}>{children}</Context.Provider>;
};

export const useModalAskContext = () => useContext(Context);
